import { render } from "./UninvestedFunds.vue?vue&type=template&id=131d1849"
import script from "./UninvestedFunds.vue?vue&type=script&lang=js"
export * from "./UninvestedFunds.vue?vue&type=script&lang=js"
script.render = render

export default script